import { styled } from 'styled-components'

export const Container = styled.div`
  background: ${(props) => props.theme.colors.grayBackgroundWhite};
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
`
